import { apiClient } from '../api/fetchClient';
import type { AccountSettingsResponse, CustomerAccountsSettings } from '../models/common.model';

class CommonService {
  async getAccountSettings(): Promise<AccountSettingsResponse> {
    return await apiClient.get<AccountSettingsResponse>('/apps/single/v3/account-settings');
  }

  async sendCustomerAccountActivation(email: string): Promise<void> {
    await apiClient.post<void>(
      `/apps/single/v3/customer/invite?email=${encodeURIComponent(email)}`
    );
  }

  async getCustomerAccountsSettings(): Promise<CustomerAccountsSettings> {
    return await apiClient.get<CustomerAccountsSettings>(
      '/apps/single/v3/account-settings/customer-accounts'
    );
  }
}

export const commonService = new CommonService();
